import { FC } from "react";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { RefreshCw01 } from "~/icons";
import { fontSizes } from "~/utils/theme";

const { sm, md, x1l } = fontSizes;

const forceReload = (): void => {
  window.location.reload();
};

const text = {
  description: "Please reload the page to see the changes.",
  title: "We've made changes to our site.",
};

export const Toast: FC = () => {
  return (
    <Flex alignItems="center" bg="bg-main-accent" p={3}>
      <Box>
        <Text color="on-accent" fontSize={md} fontWeight="bold">
          {text.title}
        </Text>
        <Text color="on-accent" fontSize={sm}>
          {text.description}
        </Text>
      </Box>
      <IconButton
        aria-label="Refresh page"
        boxShadow="none"
        colorScheme="newBrightGreen"
        icon={<RefreshCw01 h={x1l} w={x1l} />}
        onClick={forceReload}
        ml={4}
        variant="solidBright"
      />
    </Flex>
  );
};
